import { Pagination } from "@legal-500/legal500-design-system";
import styles from "./PaginationControls.module.css";

type PaginationControlsProps = {
  currentPage: number;
  totalPages: number;
  startIndex: number;
  endIndex: number;
  totalCount: number;
  itemName: string;
  onPageChange: (page: number) => void;
};

export function PaginationControls({
  currentPage,
  totalPages,
  startIndex,
  endIndex,
  totalCount,
  itemName,
  onPageChange,
}: PaginationControlsProps) {
  if (totalCount === 0) return null;

  return (
    <div className={styles.paginationControls}>
      <span className={styles.paginationText}>
        Showing {startIndex + 1}-{Math.min(endIndex, totalCount)} of {totalCount} {itemName}
      </span>

      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
          size="medium"
          showFirstLast={true}
          maxVisiblePages={5}
          variant="simple"
        />
      )}
    </div>
  );
}
